// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import {
  Box,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const IconSkeleton = () => (
  <Box ml={2}>
    <Skeleton variant="circle" height={24} width={24} />
  </Box>
);
export default IconSkeleton;
